module.exports = __webpack_public_path__ + "static/media/celular.e3b10d5a.svg";